export const COLORS = {
    text: {
      light: 'hsl(0deg, 0%, 10%)', // white
      dark: 'hsl(0deg, 0%, 100%)' // black
    },
    background: {
      light: 'hsl(0deg, 0%, 100%)', // white
      dark: 'hsl(0, 100%, 0%, 1)' // black
      // dark: '#102240'
    },
    darkBgText: {
      light: 'hsl(0deg, 0%, 100%)',
      dark: '#6D86A1',
    },
    darkBgHeading: {
      light: 'hsl(0deg, 0%, 100%)',
      dark: '#6D86A1'
    },
    primary: {
      light: '#85E9CA',
      dark: '#85E9CA'
    },
    secondary: {
      light: 'hsl(250deg, 100%, 50%)', // Purplish-blue
      dark: 'hsl(190deg, 100%, 40%)' // Cyan
    },
    // Grays, scaling from least-noticeable to most-noticeable
    gray300: {
      light: '#6D86A1',
      dark: 'rgba(0,0,0,0.1)',
    },
    gray500: {
      light: 'hsl(0deg, 0%, 50%)',
      dark: 'hsl(0deg, 0%, 50%)'
    },
    gray700: {
      light: 'hsl(0deg, 0%, 30%)',
      dark: 'hsl(0deg, 0%, 70%)'
    }
  }
  
  // export const COLOR_MODE_KEY = 'color-mode';
  export const COLOR_MODE_KEY = 'colorMode'
  export const INITIAL_COLOR_MODE_CSS_PROP = '--initial-color-mode'
  // export const INITIAL_COLOR_MODE_CSS_PROP = '--initial-colorMode';
  